import { useQuery } from '@tanstack/react-query';
import { fetchAgentCallDetails, type AgentCallSortClause, type AgentCallFilterClause } from '@/lib/axios/api/widgets.api';

export function useAgentCallDetails(opts: {
  callIds: string[];
  pageIndex: number;
  pageSize: number;
  sorts: AgentCallSortClause[];
  filters: AgentCallFilterClause[];
  startDate: string | undefined;
  endDate: string | undefined;
  enabled: boolean;
}) {
  const query = useQuery({
    queryKey: ['agentCallDetails', opts.callIds, opts.pageIndex, opts.pageSize, opts.sorts, opts.filters, opts.startDate, opts.endDate] as const,
    queryFn: ({ signal }) =>
      fetchAgentCallDetails({
        callIds: opts.callIds,
        pageIndex: opts.pageIndex,
        pageSize: opts.pageSize,
        sorts: opts.sorts,
        filters: opts.filters,
        startTime: opts.startDate,
        endTime: opts.endDate,
        signal,
      }),
    enabled: opts.enabled && opts.callIds.length > 0 && !!opts.startDate && !!opts.endDate,
  });

  return {
    callsPage: query.data,
    isCallsLoading: query.isPending && query.fetchStatus !== 'idle',
    isCallsError: query.isError,
    refetchCalls: query.refetch,
  };
}

export function useAgentCallFilterOptions(opts: { callIds: string[]; startDate: string | undefined; endDate: string | undefined; enabled: boolean }) {
  const query = useQuery({
    queryKey: ['agentCallFilterOptions', opts.callIds, opts.startDate, opts.endDate] as const,
    queryFn: ({ signal }) =>
      fetchAgentCallDetails({ callIds: opts.callIds, pageIndex: 0, pageSize: null, sorts: [], filters: [], startTime: opts.startDate, endTime: opts.endDate, signal }),
    enabled: opts.enabled && opts.callIds.length > 0 && !!opts.startDate && !!opts.endDate,
  });

  return query.data;
}
